import {
  REQUEST_CREATE_REVIEW,
  RECEIVE_CREATE_REVIEW,
  REQUEST_REVIEW_LIST,
  RECEIVE_REVIEW_LIST,
  SUBMIT_REVIEW,
  RECEIVE_SUBMIT_REVIEW_RESPONSE,
  RESET_REVIEW_STATE,
  RECEIVE_REVIEWS_ERROR,
  REQUEST_MORE_REVIEWS,
  RECEIVE_MORE_REVIEWS,
  SET_REVIEWS_TO_SHOW,
} from '../constants/actionTypes';

import { fakeReviewApi } from '../constants/fakeReview';
import { fakeReviewResponseApi } from '../constants/fakeReviewResponse';
import { fakeReviewListApi, fakeReviewListMoreApi } from '../constants/fakeReviewList';

import {
  receiveErrorResponse,
} from './api';

import {
  completeSignOut,
} from './auth';

import api, { apiAuth } from '../api';
//import { json } from 'stream/consumers';

export const resetReviewState = () => ({
  type: RESET_REVIEW_STATE,
});

export const requestReviewList = () => ({
  type: REQUEST_REVIEW_LIST,
});

export const receiveReviewList = (response) => ({
  type: RECEIVE_REVIEW_LIST,
  response,
});

export const requestMoreReviews = () => ({
  type: REQUEST_MORE_REVIEWS,
});

export const receiveMoreReviews = (response) => ({
  type: RECEIVE_MORE_REVIEWS,
  response,
});

export const setReviewsToShow = (reviewsToShow) => ({
  type: SET_REVIEWS_TO_SHOW,
  reviewsToShow,
});

export const requestCreateReview = () => ({
  type: REQUEST_CREATE_REVIEW,
});

export const receiveCreateReview = (response) => ({
  type: RECEIVE_CREATE_REVIEW,
  response,
});

export const submitReview = () => ({
  type: SUBMIT_REVIEW,
});

export const receiveSubmitReviewResponse = (data) => ({
  type: RECEIVE_SUBMIT_REVIEW_RESPONSE,
  message: data.message,
});

export const receiveReviewsError = (error) => ({
  type: RECEIVE_REVIEWS_ERROR,
  error,
});

// For live
export function fetchCreateReview(uuid) {
  return function(dispatch) {
    dispatch(requestCreateReview());
    return apiAuth(`/v1/review/leave-a-review?booking_uuid=${uuid}`)
      .then((response) => {
        dispatch(receiveCreateReview(response.data));
      })
      .catch((err) => {
        dispatch(receiveErrorResponse(err));
        if(err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}
export function fetchCreateReviewPublic(uuid, token) {
  return function(dispatch) {
    dispatch(requestCreateReview());
    return api.get(`/v1/review/leave-public-review?booking_uuid=${uuid}&token=${token}`)
      .then((response) => {
        dispatch(receiveCreateReview(response.data));
      })
      .catch((err) => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

export function postReviewForm(formData, xcsrfToken) {
  return function(dispatch) {
    dispatch(submitReview());
    return apiAuth('/v1/review/store', 'post', xcsrfToken, formData)
      .then((response) => {
        dispatch(receiveSubmitReviewResponse(response.data));
      })
      .catch((err) => {
        dispatch(receiveErrorResponse(err));
        if(err === 'No current user') {
          dispatch(completeSignOut());
        }
      });
  };
}

export function postReviewFormPublic(formData, xcsrfToken) {
  return function(dispatch) {
    dispatch(submitReview());

    const headers = {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': xcsrfToken
    };

    return api.post('/v1/review/store-public-review', formData, { headers })
      .then((response) => {
        dispatch(receiveSubmitReviewResponse(response.data));
      })
      .catch((err) => {
        dispatch(receiveErrorResponse(err));
      });
  };
}

export function fetchReviewList(slug) {
  return function(dispatch) {
    dispatch(requestReviewList());
    return api.get(`/v1/review?slug=${slug}`)
      .then((response) => {
        dispatch(receiveReviewList(response.data));
      })
      .catch((err) => {
        dispatch(receiveReviewsError(err));
      });
  };
}

export function fetchMoreReviews(slug, offset=0, limit=2) {
  return function(dispatch) {
    dispatch(requestMoreReviews());
    return api.get(`/v1/review?slug=${slug}&offset=${offset}&limit=${limit}`)
      .then((response) => {
        dispatch(receiveMoreReviews(response.data));
      })
      .catch((err) => {
        dispatch(receiveReviewsError(err));
      });
  };
}

export function postContactUsForm(formData, xcsrfToken) {

  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': xcsrfToken
  };

  return api.post('/v1/helpsupport/send', formData, { headers })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return JSON.parse('{"status": "danger"}');
    });
}

export function postRecaptcha(formData, xcsrfToken) {

  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': xcsrfToken
  };

  return api.post('v1/keepmeinform/recaptcha', formData, { headers })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return JSON.parse('{"status": "danger"}');
    });
}

export function postKmiForm(formData, xcsrfToken) {

  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': xcsrfToken
  };

  if(formData.hasOwnProperty('user_consent')){
    if (formData['user_consent'] === '1')
      formData['user_consent'] = 1;
  }
  else if(!formData.hasOwnProperty('user_consent')){
    formData['user_consent'] = 0;
  }

  return api.post('/v1/keepmeinform/send', formData, { headers })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      return JSON.parse('{"status": "danger"}');
    });
}

// For test
// export function fetchCreateReview(uuid) {
//     return function(dispatch) {
//         dispatch(requestCreateReview());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 500);
//         }).then(() => dispatch(receiveCreateReview(fakeReviewApi)));
//     };
// }

// export function postReviewForm(formData, xcsrfToken) {
//     return function(dispatch) {
//         dispatch(submitReview());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 500);
//         }).then(() => dispatch(receiveSubmitReviewResponse(fakeReviewResponseApi)));
//     };
// }

// export function fetchReviewList(slug) {
//     return function(dispatch) {
//         dispatch(requestReviewList());
//         return new Promise((resolve, reject) => {
//             setTimeout(resolve, 500);
//         }).then(() => dispatch(receiveReviewList(fakeReviewListApi)))
//             .catch((err) => dispatch(receiveReviewsError('fail')));
//     };
// }

// export function fetchMoreReviews(slug, offset=0, limit=2) {
//     return function(dispatch) {
//         dispatch(requestMoreReviews());
//         return new Promise((resolve, reject) => {
//             setTimeout(reject, 500);
//         }).then(() => dispatch(receiveMoreReviews(fakeReviewListMoreApi)))
//             .catch((err) => dispatch(receiveReviewsError('fail')));
//     };
// }
